import BalanceChange, {
    BalanceChangeProps,
} from '@/components/common/BalanceChange';
import { useQuery } from '@apollo/client';
import { AnyFinancialEntity } from '@common/financialEntities';
import {
    BalanceChangeDateRange,
    HistoricalBalanceChangeDocument,
} from '@common/graphql/generated';

interface HistoricalBalanceChangeProps
    extends Omit<
        BalanceChangeProps,
        'change' | 'dateRange' | 'onChangeDateRange'
    > {
    dateRange: BalanceChangeDateRange;
    onChangeDateRange?: (dateRange: BalanceChangeDateRange) => void;
    positiveAccounts: AnyFinancialEntity[];
    negativeAccounts?: AnyFinancialEntity[];
    swapColors?: boolean;
}

const HistoricalBalanceChange = ({
    dateRange,
    onChangeDateRange,
    positiveAccounts,
    negativeAccounts = [],
    swapColors,
    ...props
}: HistoricalBalanceChangeProps) => {
    const { data } = useQuery(HistoricalBalanceChangeDocument, {
        variables: {
            dateRange,
            positiveFinancialEntityIds: positiveAccounts.map((a) => a.id),
            negativeFinancialEntityIds: negativeAccounts.map((a) => a.id),
        },
        fetchPolicy: 'no-cache',
    });

    if (!data?.historicalBalanceChange) return null;

    return (
        <BalanceChange
            dateRange={dateRange}
            onChangeDateRange={onChangeDateRange}
            change={data.historicalBalanceChange}
            swapColors={swapColors}
            {...props}
        />
    );
};

export default HistoricalBalanceChange;
